const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* =====================================================================
   Round 40 — mobile nav overlay fix
   Added here because constants.js is loaded on every page.

   Keeps the CSS variable --header-height in sync with the ACTUAL fixed
   header bar (.fm-header-wrapper). The theme's sticky .section-header
   collapses to 0px (its visible bar is position:fixed), so the value the
   theme normally computes is 0 — which left the mobile menu drawer with a
   wrong top offset. The mobile drawer CSS positions itself using
   var(--header-height), so this keeps it sitting directly under the bar.

   Uses direct event handlers + a setTimeout throttle (not requestAnimation-
   Frame) so it still updates in background / throttled tabs.
   ===================================================================== */
(function () {
  function applyHeaderHeight() {
    var bar = document.querySelector('.fm-header-wrapper');
    if (!bar) return;
    var bottom = bar.getBoundingClientRect().bottom;
    if (bottom < 0) bottom = 0;
    document.documentElement.style.setProperty('--header-height', Math.round(bottom) + 'px');
  }
  var timer = null;
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () {
      timer = null;
      applyHeaderHeight();
    }, 100);
  }
  applyHeaderHeight();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyHeaderHeight);
  }
  window.addEventListener('load', applyHeaderHeight);
  window.addEventListener('resize', schedule);
  window.addEventListener('orientationchange', applyHeaderHeight);
  window.addEventListener('scroll', schedule, { passive: true });
})();
